"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DocumentCitationAnchor = void 0;
exports.webappDocumentUrl = webappDocumentUrl;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _chatCitations = require("../../utils/chat-citations");
var _envManager = require("../../utils/envManager");
var _openInBrowserWindow = require("../../utils/open-in-browser-window");
var _jsxRuntime = require("react/jsx-runtime");
var _templateObject, _templateObject2;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function webappDocumentUrl(href) {
  var webappBase = (0, _envManager.getEnv)("WEBAPP_API_BASE_URL");
  return webappBase ? new URL(href, webappBase).toString() : href;
}
var BookmarkButton = _styledComponents.default.button(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: var(--primary);\n  color: white;\n  border: none;\n  border-radius: 4px;\n  padding: 2px 6px;\n  margin: 0 2px;\n  cursor: pointer;\n  font-size: 12px;\n  display: inline-block;\n  transition: background-color 0.2s;\n\n  &:hover {\n    background-color: var(--background-primary-hover);\n  }\n"])));
var StyledLink = _styledComponents.default.a(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: var(--primary);\n  text-decoration: underline;\n\n  &:hover {\n    color: var(--background-primary-hover);\n  }\n"])));
var DocumentCitationAnchor = exports.DocumentCitationAnchor = function DocumentCitationAnchor(_ref) {
  var href = _ref.href,
    inFocusDocumentId = _ref.inFocusDocumentId,
    onSelectBookmarks = _ref.onSelectBookmarks,
    children = _ref.children;
  var bookmarks = (0, _chatCitations.focusedDocBookmarkRange)(href, inFocusDocumentId);
  if (bookmarks) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(BookmarkButton, {
      type: "button",
      "aria-label": "View cited section",
      title: "Click to view cited section",
      onClick: function onClick() {
        return onSelectBookmarks(bookmarks);
      },
      children: children
    });
  }
  var absolute = webappDocumentUrl(href);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledLink, {
    href: absolute,
    onClick: function onClick(e) {
      e.preventDefault();
      (0, _openInBrowserWindow.openInBrowserWindow)(absolute);
    },
    "data-sentry-element": "StyledLink",
    "data-sentry-component": "DocumentCitationAnchor",
    "data-sentry-source-file": "DocumentCitationAnchor.tsx",
    children: children
  });
};